import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const ErrorWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.space.mobile.tiny};
`

export const NoteWrapper = styled.div`
  display: block;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.huge};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.huge};
  `};
`

export const Footer = styled.div`
  display: block;
  text-align: center;

  ${({ theme }) => `
    color: ${theme.color.white};
    margin-top: ${theme.space.mobile.large};
  `}

  ${({ theme }) => media.sm`
    margin-top: ${theme.space.desktop.large};
  `};
`

export const BackButtonWrapper = styled.div`
  ${({ theme }) => `
    margin-bottom: calc(${theme.space.mobile.base} * 4);
  `};

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.huge};
  `};
`
